export default "__VITE_ASSET__Bda2miZO__"